import { isPlatformBrowser, SlicePipe } from '@angular/common';
import { Component, Inject, inject, Input, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { BuilderService } from '@banyan/modules/builder-io/services/builder.service';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';

@Component({
  selector: 'app-banner-with-action',
  standalone: true,
  imports: [
    ButtonComponent,
    SlicePipe,
  ],
  templateUrl: './banner-with-action.component.html',
  styleUrl: './banner-with-action.component.scss'
})
export class BannerWithActionComponent {
  @Input() title: string = '';
  @Input() subTitle: string = '';
  @Input() btnText: string = '';
  @Input() btnUrl: string = '';
  @Input() btnIcon: string = '';
  @Input() isExternalLink: boolean = false;
  @Input() closeButton: boolean = true;
  builderService = inject(BuilderService);
  router = inject(Router);

  constructor(@Inject(PLATFORM_ID) private readonly platformId: any) {
  }

  closeBanner() {
    this.builderService.bannerContent.set(null);
  }

  openUrl(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.isExternalLink) {
        window.open(this.btnUrl, '_blank');
      } else {
        this.router.navigate([this.btnUrl]);
      }
    }
  }
}
